module.exports = __webpack_public_path__ + "static/media/Assurity.43da3113.webp";